import _ from 'underscore'
import {createSelector} from 'reselect'
import {ResetStatus} from './common'

export const getPasswordSettingsState = state => state.passwordSettings

export const getMinimalPasswordLength = state => getPasswordSettingsState(state).settings.minimalLength;
export const getMinPasswordLengthError = state => getPasswordSettingsState(state).minimalLengthError

export const getOldPasswordSettings = state => getPasswordSettingsState(state).initialSettings;

export const getTurnedOnConfigurablePasswordRules = state => {
    let {settings: {ruleIds}, configurableRuleIds} = getPasswordSettingsState(state);
    return _.intersection(ruleIds, configurableRuleIds);
}
export const getConfigurablePasswordRules = state => getPasswordSettingsState(state).configurableRuleIds

export const isAnyPasswordRequirementOn = state => getTurnedOnConfigurablePasswordRules(state).length > 0

export const getResetState = state => getPasswordSettingsState(state).resetStatus

export const isBeginToReset = state => _.contains([ResetStatus.Resetting, ResetStatus.ResettingAndSaving], getResetState(state))

export const getModificationState = state => getPasswordSettingsState(state).saveStatus

export const getRawSettings = state => getPasswordSettingsState(state).settings

export const isPasswordRulesGotStronger = state => getPasswordSettingsState(state).settingsGotStronger

export const getPasswordNotResetFor = state => getPasswordSettingsState(state).passwordNotResetFor

export const getCurrentPassword = state => getPasswordSettingsState(state).currentPassword
export const getNewPassword = state => getPasswordSettingsState(state).newPassword
export const isCurrentPasswordInvalid = state => getPasswordSettingsState(state).currentPasswordInvalid
export const isNewPasswordInvalid = state => getPasswordSettingsState(state).newPasswordInvalid
export const getPasswordValidationResult = state => getPasswordSettingsState(state).passwordValidationResult

export const isUserPasswordMatchesPolicy = createSelector(
    getPasswordSettingsState,
    passwordSettingsState => passwordSettingsState.isUserPasswordMatchesPolicy
)



// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/selectors.js